// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileComment__wrap--1VphO{display:grid;gap:16px;padding:0 12px}.ProfileComment__item--2pFTG{margin:0 -24px -24px}\n", "",{"version":3,"sources":["webpack://./next/components/ProfileComment/style.module.sass"],"names":[],"mappings":"AAEA,6BACC,YAAa,CACb,QAAS,CACT,cAAe,CAAG,6BAGlB,oBAAqB","sourcesContent":["@import 'next/styles/_meta.sass';\n\n.wrap {\n\tdisplay: grid;\n\tgap: 16px;\n\tpadding: 0 12px; }\n\n.item {\n\tmargin: 0 -24px -24px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "ProfileComment__wrap--1VphO",
	"item": "ProfileComment__item--2pFTG"
};
module.exports = ___CSS_LOADER_EXPORT___;
